import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import qs from "qs";
import "./assets/pub/app.2292a686.css";
import "./assets/pub/video-detail.08469c16.css";
import "./assets/pub/usercenter.f1a6ea49.css";
import "./assets/pub/style.css";
import "./assets/pub/swiper.min.css";
import "./assets/iconfont/iconfont.css";
import axios from "axios";
import $ from "jquery";
import BootstrapVue from "bootstrap-vue";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(BootstrapVue);
Vue.config.productionTip = false;
axios.interceptors.request.use(config => {
  console.log(config);
  if(config.headers['Content-Type'] === 'multipart/form-data'){
    console.log("111")
    return config;
  }
  // console.log("5555")
  config.data = qs.stringify(config.data);
  return config;
})

// Vue.use($);
axios.defaults.baseURL = "https://admin.jzda001.com/";
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.request['Referer'] = 'https://www.jzda001.com/';
Vue.prototype.$http = axios;
Vue.prototype.$ = $;
// Vue.prototype.common = common;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
